<template>
  <div>
    <div class="ll-list-with-button title">
      <div class="title">
        {{ title }}
      </div>
      <div class="title time">
        {{ time }}
      </div>
      <div
        v-if="avatar"
        class="title time ll-avatar"
      >
        {{ avatar }}
      </div>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlBoardChecklistList",
  props: {
    title: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.ll-list-with-button {
  @include flex_align;
  padding: 10px 19px 10px 20px;
  margin-top: 20px;
  border-bottom: 1px solid var(--blue-30);
  &.title {
    padding: 15px 19px 15px 20px;
  }
  .title {
    padding-right: 20px;
    width: 240px;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 1px;
    color: var(--gray-900);
    &.time {
      width: 114px;
    }
  }
  .time {
    width: 114px;
  }
  .ll-avatar {
    @include auto_margin_left(20px);
  }
  .btn {
    margin-left: auto;
    width: 140px;
  }
}
</style>